export const isBlank = (string) => {
  return (!string || /^\s*$/.test(string));
}
